import { html, View, type Html, rune } from 'rune-ts';
import { PostMessageNavigate } from '../../../app/navigate';
import { dataStr } from '../../../util/dataStr';

import style from './ButtonCtaLanding.module.scss';
import { typoPcMo } from '../../../typography/typo';
import { entries, pipe, map, reduce } from '@fxts/core';
import { ArrowRightIcon } from '../../../../renderApp/components/atoms/Icon';

type ButtonCtaLandingType = 'blue_line' | 'white' | 'blue' | 'black' | 'hidden';

export interface ButtonCtaLandingProps {
  label: string | Html;
  submit?: boolean;
  klass?: string;
  fit?: boolean;

  attr?: Record<string, string>;
  target?: '_blank' | '_self';
  href?: string;
  type?: ButtonCtaLandingType;
  navigate?: PostMessageNavigate & object;
  is_mobile?: boolean;
}

export class ButtonCtaLanding extends View<ButtonCtaLandingProps> {
  readonly typeOptions = {
    blue_line: style.blue_line,
    white: style.white,
    blue: style.blue,
    black: style.black,
    hidden: style.hidden,
  } as const;

  override template(data: ButtonCtaLandingProps) {
    const is_mobile =
      typeof data.is_mobile === 'boolean' ? data.is_mobile : !!rune.getSharedData(this)?.is_mobile;
    const font_class = typoPcMo({ is_mobile, pc: '20_bold', mo: '16_bold' });

    return html`
      <${data.href ? 'a' : 'button'}
        data-fit="${!!data.fit}"
        class="${style.landing_cta_button} ${this.getTypeOption()} ${font_class} ${data.klass ?? ''}"
        ${
          data.href
            ? html`href="${data.href}"
              ${data.navigate ? html`data-post-message="${dataStr(data.navigate)}"` : ''}
              ${data.target ? html`target="${data.target}"` : ''} `
            : html`type="${data.submit ? 'submit' : 'button'}"`
        }
        ${
          data.attr
            ? pipe(
                data.attr,
                entries,
                map(([k, v]) => `${k}=${v}`),
                reduce((a, b) => `${a} ${b}`),
              )
            : ''
        }
      >
        ${this.data.label}
        <div class="${style.arrow_button}">${ArrowRightIcon}</div>
      </${this.data.href ? 'a' : 'button'}>
    `;
  }

  getTypeOption() {
    return (this.data.type && this.typeOptions[this.data.type]) || this.typeOptions.white;
  }

  setTypeOption(type: ButtonCtaLandingType) {
    this.data.type = type;
    this.redraw();
  }
}
